import React, { useState } from 'react';

import {Button, ModalHeader, ModalFooter, ModalBody, Typography, Row} from 'cfa-react-components';
import { parseAxiosError } from "services";
import toast from "react-hot-toast";

interface IRepeatModalProps {
    repeatNoun: string,
    target: any,
    targetFunc: (any) => Promise<any>,
    onHide: () => void,
    refresh: () => void,
}

export function RepeatModal({ repeatNoun, target, targetFunc, onHide, refresh }: IRepeatModalProps) {

    const [loading, setLoading] = useState(false);

    const repeatTarget = () => {

        setLoading(true);

        targetFunc(target)
            .then(() => {
                refresh();
                onHide();
                toast.success(`${repeatNoun} Task Re-Initialized`);
            })
            .catch((err) => {
                onHide();
                toast.error(parseAxiosError(err));
                setLoading(false);
            });
    }

    return (<>

        <ModalHeader>
            {repeatNoun} Again?
        </ModalHeader>

        <ModalBody>
            <Row>
                <Typography>
                    The Replay "{target && target.name}" will be played again as configured.
                </Typography>
            </Row>
        </ModalBody>

        <ModalFooter>
            <Button variant="outlined" onClick={onHide}>
                Close
            </Button>
            <Button
                variant="filled"
                onClick={repeatTarget}
                loading={loading}
            >
                {loading ? 'Confirming...' : 'Confirm'}
            </Button>
        </ModalFooter>

    </>);
}